import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/arbitrator_logo.png";
import LogoWhite from "../../assets/images/arbitrator_white_logo.png";
import menuIcon from "../../assets/images/menu-responsive.svg";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Collapse, Menu } from "antd";
import "./styles.css";
import { Select, Space } from "antd";
import { MdClear } from "react-icons/md";
import { BsChevronDown } from "react-icons/bs";
import { ICategories } from "../../models/categories";
import useGetAllData from "../../hooks/useGetAllData";

import { Link, useLocation } from "react-router-dom";
import { SelectedItemProvider, useSelectedItem } from "../../context/selectedItemContext";
import i18next from "i18next";

const { SubMenu } = Menu;

const HeaderResponsive = () => {
  const [visible, setVisible] = useState(false);
  const pathname = window.location.pathname;
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const { setSelectedItemName, setSpecializations } = useSelectedItem();

  const location = useLocation();

  const { data: categories } = useGetAllData<ICategories[]>({
    queryKey: ["categories"],
    url: "categories",
  });

  const findOpenKeysByPath = (categories: any[], path: string): string[] => {
    let keys: string[] = [];

    const findKeys = (items: any[], parentKey: string[] = []): boolean => {
      for (const item of items) {
        const currentKey = [...parentKey, item.id.toString()];
        if (item.path === path || path.includes(`${item.path}/:${item.id}`)) {
          keys = currentKey;
          setSelectedItemName(item.name); // category nameni contextga saqlash
          setSpecializations(item.specializations || null); //categoryni setSpecializations ni contextga saqlash
          return true;
        }
        if (item.children && findKeys(item.children, currentKey)) {
          return true;
        }
      }
      return false;
    };

    findKeys(categories);
    return keys;
  };

  useEffect(() => {
    if (categories) {
      const path = location.pathname;
      const keys = findOpenKeysByPath(categories, path);
      setSelectedKeys([keys[keys.length - 1]]);
      setOpenKeys(keys.slice(0, keys.length - 1));
    }
  }, [location.pathname, categories]);

  const handleOpenChange = (keys: string[]) => {
    const rootSubmenuKeys = categories.map((item: any) => item.id.toString());
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const renderMenuItems = (items: any[]) => {
    return items.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
        <SubMenu key={item.id} title={item.name} style={{                
          borderRadius: 0,
          borderTopLeftRadius: "10px",
          borderBottomLeftRadius: "10px",
          fontSize: "18px",
          fontWeight: 400,
          fontFamily: "IBM Plex Sans",
          color:"white",
          background:"transparent"
          }}>
            {renderMenuItems(item.children)}
          </SubMenu>
        );
      }

      return (
        <>
          {item?.path === "/" ? null : (
            <Menu.Item
              key={item.id}
              style={{
                background:
                  location.pathname === `${item.path}/:${item.id}`
                    ? "transparent"
                    : location?.pathname == item?.path
                    ? "transparent"
                    : "",
                color:
                  location.pathname === `${item.path}/:${item.id}`
                    ? "white"
                    : location?.pathname == item?.path
                    ? "white"
                    : "white",
                borderRadius: 0,
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
                fontSize: "18px",
                fontWeight: 400,
                fontFamily: "IBM Plex Sans",
              }}
            >
              <Link
                key={item?.path}
                to={
                  item?.path === "/calculator"
                    ? "/calculator"
                    : item?.path === "/contact"
                    ? "/contact"
                    : item?.path === "/contact-us"
                    ? "/contact-us"
                    : `${item.path}/:${item.id}`
                }
              >
                {item.name}
              </Link>
            </Menu.Item>
          )}
        </>
      );
    });
  };

  useEffect(() => {
    setVisible(false);
  }, [pathname]);
  return (
    <>
      <nav className="flex justify-between items-center py-2 lg:hidden">
        <Link to={"/"} className="flex items-center w-[170px]">
          <img src={Logo} alt="logo" className="min-w-[160px] h-[65px] mr-5" />
        </Link>
        <div
          className="cursor-pointer w-20"
          onClick={() => setVisible(!visible)}
        >
          <img src={menuIcon} alt="menuBar" />
        </div>
      </nav>
      {visible && (
        <div className="header_responsive fixed top-0 left-0 w-full bg-[#29487E] h-screen overflow-y-auto z-50">
          <div className="sm:flex hidden justify-between items-center py-5 border-b border-white  sm:px-10 px-5">
            <Link to={"/"}>
              <img
                src={LogoWhite}
                alt="logo"
                className="min-w-[200px] h-[100px] object-cover mr-5"
              />
            </Link>
            <div
              className="cursor-pointer rounded-3xl py-4 px-5  bg-[#D9D9D94D]"
              onClick={() => setVisible(!visible)}
            >
              <FaArrowLeftLong size={25} color="white" />
            </div>
          </div>
          <div className="sm:hidden flex justify-between items-center py-5 border-b border-white sm:px-10 px-5 header-select">
            <Select

              defaultValue={localStorage.getItem('i18lang')}
              onChange={(value) => {
                localStorage.setItem('i18lang', value );
                i18next.changeLanguage(value);
              }}
              suffixIcon={<BsChevronDown size={20} color="#7ECFFF" />}
              variant="borderless"
              style={{ width: 80 }}
              options={[
                { value: "en", label: "EN" },
                { value: "uz", label: "UZ" },
                { value: "ru", label: "RU" },
              ]}
            />
            <div onClick={() => setVisible(!visible)}>
              <MdClear size={36} color="white" />
            </div>
          </div>
          <div className="sm:px-10 px-5 pt-5 navbar-menu">
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onOpenChange={handleOpenChange}
              style={{
                height: "100%",
                background: "transparent",
                width: "100%",
                paddingTop: "20px",
              }}
            >
              {categories && renderMenuItems(categories)}
            </Menu>

            <div className="flex gap-4 justify-between sm:text-base text-base text-center mt-16 font-semibold items-center">
              <Link
                to={"/login"}
                className="w-1/2 sm:py-3 py-2 bg-[#29487E] text-white rounded-lg border border-white"
              >
                Login
              </Link>
              <Link
                to={"/register"}
                className="w-1/2 sm:py-3 py-2 bg-white text-[#29487E] rounded-lg"
              >
                Registration
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const HeaderResponsiveWithProvider: React.FC = () => (
  <SelectedItemProvider>
    <HeaderResponsive/>
  </SelectedItemProvider>
);

export default HeaderResponsiveWithProvider;
